import * as React from 'react';
import { ElementLoader, ValidationProps } from 'ui';
import { SimpleFormComponentProps, SerializeType, SimpleFormProps } from 'app/infrastructure/simple-form/types';
import { FIELD_TYPE } from 'app/infrastructure/simple-form';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { form, pushNameMaxLength, pushNameMinLength } from 'app/area/user-profile/my-notifications/constants';
import { Consent } from 'app/area/user-profile/my-notifications/types';
import { SharedState } from 'app/types-shared';

import styles from './push-modal.scss';
import { getPushName } from 'app/area/user-profile/my-notifications/consents/get-push-name';
import { UAParser } from 'ua-parser-js';
import { Messaging } from 'app/infrastructure/push/types';

interface PushModalProps {
  id?: number;
  recipientId: number;
  consent?: Consent;
  consents: Consent[];

  value: Messaging;

  fetching: boolean;
  formComponent: React.ComponentType<SimpleFormComponentProps>;
  translation?: { [key: string]: string };
  validation: { [key: string]: ValidationProps };
  sharedState?: SharedState;

  onDone: () => void;
  onClose: () => void;
  loadConsent?: (id: number, recipientId: number) => void;
  clearConsent?: () => void;
  clearValidation: (fieldName: string) => void;
}

export type PushModalContainerProps = PushModalProps & SimpleFormProps;

export class PushModal extends React.PureComponent<PushModalContainerProps, any> {

  public componentDidMount() {
    const { id, sharedState: { id: recipientId } } = this.props;

    this.clearValidation();

    if (id && recipientId) {
      this.props.clearConsent();
      this.props.loadConsent(id, recipientId);
    }
  }

  private clearValidation = () => {
    if (!!this.props.validation) {
      this.props.clearValidation(form.push.name);
    }
  };

  private isDisabled = () => {
    const { id, sharedState: { id: recipientId }, consent, fetching, formValues } = this.props;
    return fetching || String(formValues[form.push.name]).length < pushNameMinLength || (id && recipientId && !(consent && consent.value));
  };

  public render() {
    const { id, sharedState: { id: recipientId }, consent, fetching, formComponent: SimpleForm, onClose, translation, onDone } = this.props;

    return <ModalWrapper
      headerTitle={(id && recipientId) ? translation.edit_push_title : translation.add_push_title}
      btnTitle={translation.save}
      btnCancelTitle={translation.cancel}
      onDone={onDone}
      onClose={onClose}
      closeOnDone={false}
      isDisabled={this.isDisabled}
      canCloseOnBackground={false}>

      {((id && recipientId && !(consent && consent.value)) || fetching) && <ElementLoader />}

      {(id && recipientId && consent && consent.value) || (!id && !consent) && !fetching
        ? <div className={styles.wrapper}>
          <div className={styles.input}>
            <SimpleForm
              name={form.push.name}
              type={FIELD_TYPE.TEXTAREA}
              label={{ text: translation.push_name, required: true }}
              initialValue={id ? consent.value.name : getPushName(new UAParser())}
              maxLength={pushNameMaxLength}
              serialize={{ type: SerializeType.PRIMITIVE_VALUE }}
              readOnly={false} />
          </div>
        </div>
        : null}
    </ModalWrapper>;
  }
}
